import React, { Fragment, useRef, useEffect, useState } from "react";
import { SelectBox } from "devextreme-react/select-box";
import { DateBox } from "devextreme-react/date-box";
import { TextBox } from "devextreme-react/text-box";
import { CheckBox, NumberBox } from "devextreme-react";
import moment from "moment";
import {
  GET_DIRECT_CALL_INFO,
  GET_CUSTOMER_LIST,
  SAVE_DIRECT_CALL,
} from "../utils/endPoints";
import { useHistory } from "react-router-dom";

import { makeWorkdeskActive } from "../ConstVariable";

import { Button } from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Validator, { RequiredRule, AsyncRule } from "devextreme-react/validator";
import { TextArea } from "devextreme-react";
import ConnectionManager from "../WebSocketService/ConnectionManager";

const DirectCall = (props) => {
  const { operatorAssignedCenters } = useSelector((state) => state);
  const [caller_type_data, setCallerTypeData] = useState(['Referrer', 'Patient', 'Others'])
  const call_context_referrer = [{ 'name': 'Report Enquiry / Dispatch', 'value': 'REPORT_ENQUIRY_DISPATCH' }, { 'name': 'Talk to Radiologist', 'value': 'TALK_TO_RADIOLOGIST' }, { 'name': 'Urgent Booking', 'value': 'URGENT_BOOKING' }, { 'name': 'Miscellaneous', 'value': 'MISC' }]
  const call_context_patient = [{ 'name': 'Appointment Cancellation', 'value': 'APPOINTMENT_CANCELLATION' }, { 'name': 'Appointment Rescheduling', 'value': 'APPOINTMENT_RESCHEDULING' }, { 'name': 'Report Enquiry', 'value': 'REPORT_ENQUIRY' }, { 'name': 'Address Enquiry', 'value': 'ADDRESS_ENQUIRY' }, { 'name': 'Miscellaneous', 'value': 'MISC' }, { 'name': 'Cost Enquiry', 'value': 'COST_ENQUIRY' }]
  const call_template_referrer = [{
    'name': 'REPORT_ENQUIRY_DISPATCH',
    'value': [
      {
        'name': 'Report Not Available',
        'value': 'The doctor enquired about the report for the following patient, which is not yet finalized.\nWe have informed the same to the doctor.\n\nPatient Name :\nPatient DOB :\nScan :\nScan Performed On :\n\nPlease contact the doctor if required.\n<<Enter more details>>', 'send_email': true
      },
      {
        'name': 'Report Available',
        'value': 'The doctor enquired about the report for the following patient\n\nPatient Name :\nPatient DOB :\nScan :\nScan Date :\n\nThe report has been e-faxed to the doctor', 'send_email': false
      }

    ]
  },
  {
    'name': 'TALK_TO_RADIOLOGIST',
    'value': [
      {
        'name': 'Speak to the Radiologist',
        'value': 'The doctor wants to talk to the Reporting Radiologist <<Name>>.\nHe wants to discuss the report for the following patient\n\nPatient Name :\nPatient DOB :\nScan :\n\nWe have informed him that he will receive the call back.', 'send_email': true
      }
    ]
  },
  {
    'name': 'URGENT_BOOKING',
    'value': [
      {
        'name': 'Booking Cannot be done by AI',
        'value': 'The doctor called to make a booking for one of the patient\n\nPlease find the details\n\nPatient Name :\nPatient DOB :\nScan :\n\nAs there is no immediate slot available to fit in the patient, informed the doctor that he/ his patient will receive a callback from the reception. Please call back and do the needful.', 'send_email': true
      }
    ]
  },
  {
    'name': 'MISC',
    'value': [
      {
        'name': 'General Call',
        'value': 'The doctor called for\n\n<<mention details>>', 'send_email': false
      }
    ]
  }

  ]

  const call_template_patient = [{
    'name': 'REPORT_ENQUIRY',
    'value': [
      {
        'name': 'Report Not Available',
        'value': 'The doctor enquired about the report for the following patient, which is not yet finalized.\nWe have informed the same to the doctor.\n\nPatient Name :\nPatient DOB :\nScan :\nScan Performed On :\n\nPlease contact the doctor if required.\n<<Enter more details>>', 'send_email': true
      },
      {
        'name': 'Report Available',
        'value': 'The doctor enquired about the report for the following patient\n\nPatient Name :\nPatient DOB :\nScan :\nScan Date :\n\nThe report has been e-faxed to the doctor', 'send_email': false
      }

    ]
  },
  {
    'name': 'APPOINTMENT_CANCELLATION',
    'value': [
      {
        'name': 'No Cancellation allowed by AI',
        'value': 'The patient called to cancel the existing appointment\n\nPlease find the details\n\nScan :\nAppointment Date/Time :\n\nAs we are not allowed to cancel the booking, please call the patient and do the needful.', 'send_email': true
      },
      {
        'name': 'Specific Cancellation not allowed by AI',
        'value': 'The patient called to cancel the existing appointment\n\nPlease find the details\n\nScan :\nAppointment Date/Time :\n\nAs we are not allowed to cancel the <<SCAN>> booking, please call the patient and do the needful.', 'send_email': true
      },
      {
        'name': 'Cancellation Done Successfully',
        'value': 'The patient called to cancel the existing appointment.\nWe have cancelled the appointment\n\nPlease find the details\n\nScan :\nAppointment Date/Time :\nReason For Cancellation : ', 'send_email': true
      }

    ]
  },
  {
    'name': 'APPOINTMENT_RESCHEDULING',
    'value': [
      {
        'name': 'Appointment Modification not allowed by AI',
        'value': 'The patient called to change the existing appointment\n\nScan :\nAppointment Date/Time :\n\nAs we are not allowed to book/reschedule the <<scan>>, please contact the patient and do the needful.', 'send_email': true
      },
      {
        'name': 'Rescheduling Done',
        'value': 'The patient called to reschedule the existing appointment.\nWe have changed the appointment\n\nPlease find the details\n\nScan :\nPrior Appointment Date/Time :\nNew Appointment Date/Time :\nReason For Rescheduling :\n ', 'send_email': false
      }

    ]
  },
  {
    'name': 'ADDRESS_ENQUIRY',
    'value': [
      {
        'name': 'General Address Enquiry',
        'value': 'The patient called to find the adress of the center. He/She has the booking for today for <<scan>>.\n\nWe have provided the center address', 'send_email': false
      }
    ]
  },
  {
    'name': 'MISC',
    'value': [
      {
        'name': 'General Call',
        'value': "The patient called for\n\n<<mention details>>", 'send_email': false
      }
    ]
  },
  {
    'name': 'COST_ENQUIRY',
    'value': [
      {
        'name': 'Informed the cost',
        'value': 'The patient called for\n\n<<mention details>>', 'send_email': false
      },
      {
        'name': "Didn't Inform the cost",
        'value': 'The patient called to enquiry the scan cost\n\nPatient type: Medicare/ Private/ Pensioner\nScan : \n\nAs we are not aware about the exact pricing, informed the patient to wait for a call from the reception.\n\nPlease contact the patient and do the needful.', 'send_email': true
      }

    ]
  },


  ]
  const [call_context_data, setCallContextData] = useState([])
  const [dob_disable, setDOBDisable] = useState(false);
  const [more_details_visible, setMoreDetailsVisible] = useState(false);
  const [call_context_visible, setCallContextVisible] = useState(true);
  const [centerList, setCenterList] = useState([]);
  const [form_height, setFormHeight] = useState('690');
  const [message_box_visible, setMessageBoxVisible] = useState(false);
  const [send_email, setSendEmail] = useState(false);
  const [read_only, setReadOnly] = useState(false)


  const [center_name, setCenterName] = useState({ "is_valid": 'valid', "value": null });
  const [caller_number, setCallerNumber] = useState({ "is_valid": 'valid', "value": null });
  const [caller_type, setCallerType] = useState({ "is_valid": 'valid', "value": null });
  const [caller_name, setCallerName] = useState({ "is_valid": 'valid', "value": null });
  const [patient_dob, setPatientDOB] = useState({ "is_valid": 'valid', "value": null });
  const [call_context, setCallContext] = useState({ "is_valid": 'valid', "value": null });
  const [call_notes, setCallNotes] = useState({ "is_valid": 'valid', "value": null });
  const [call_summary, setCallSummary] = useState({ "is_valid": 'valid', "value": null })
  const [checkbox, setCheckBox] = useState(false);
  const [checkbox2, setCheckBox2] = useState(false);
  const [checkMail, setCheckMail] = useState(false)
  const [more_details, setMoreDetails] = useState({ "is_valid": 'valid', "value": null });
  const [sms_text, setSmsText] = useState({ "is_valid": 'valid', "value": null });
  const [call_template, setCallTemplate] = useState([]);
  const [is_call_template_requeired, setCallTemplateVisible] = useState('valid')
  const [is_update, setIsUpdate] = useState(false)
  const [sendingRequest, setSendingRequest] = useState(false)







  const handleCenterName = (e) => {
    setCenterName({ 'is_valid': 'valid', 'value': e?.value })
  }

  const handleCallTemplate = (e) => {
    setCallSummary({ 'is_valid': 'valid', 'value': e?.value?.name })
    setCallNotes({ 'is_valid': 'valid', 'value': e?.value?.value })
    setSendEmail(e?.value?.send_email)
    setCallTemplateVisible('valid')

  }
  const handleSmsText = (e) => {
    setSmsText({ 'is_valid': 'valid', 'value': e?.value })
  }

  const handleCallerNumber = (e) => {
    setCallerNumber({ 'is_valid': 'valid', 'value': e?.value })

  }
  const handleMoreDetails = (e) => {
    setMoreDetails({ 'is_valid': 'valid', 'value': e?.value })

  }
  const handleCallerType = (e) => {
    setCallerType({ 'is_valid': 'valid', 'value': e?.value })

    if (e?.value == 'Referrer') {
      setDOBDisable(false)
      setCallContextData(call_context_referrer)
      setMoreDetailsVisible(false);
      setCallContextVisible(true)
      setMoreDetails({ "is_valid": 'valid', "value": null })
      setCallerName({ 'is_valid': 'valid', 'value': 'Dr ' })



    }
    else if (e?.value == 'Patient') {
      setDOBDisable(true)
      setCallContextData(call_context_patient)
      setMoreDetailsVisible(false);
      setCallContextVisible(true)
      setMoreDetails({ "is_valid": 'valid', "value": null })
      setCallerName({ 'is_valid': 'valid', 'value': null })





    }
    else {
      setMoreDetailsVisible(true);
      setDOBDisable(false);
      setCallContextData(null);
      setCallContextVisible(false)
      setCallContext({ "is_valid": 'valid', "value": null })
      setPatientDOB({ "is_valid": 'valid', "value": null })
      setCallerName({ 'is_valid': 'valid', 'value': null })




    }
  }
  const handleCallerName = (e) => {

    setCallerName({ 'is_valid': 'valid', 'value': e?.value })
  }
  const handlePatientDOB = (e) => {
    setPatientDOB({ 'is_valid': 'valid', 'value': e?.value })

  }
  const handleCallContext = (e) => {
    setCallContext({ 'is_valid': 'valid', 'value': e?.value })
    setCallNotes({ "is_valid": 'valid', "value": null })
    if (e?.value == 'MISC') {
      setCheckMail(true)
    }
    else {
      setCheckMail(false)

    }

    if (caller_type.value == 'Referrer') {
      for (let i = 0; i < call_template_referrer.length; i++) {
        if (call_template_referrer[i].name == e.value) {
          setCallTemplate(call_template_referrer[i].value)
        }
      }


    }
    else if (caller_type.value == 'Patient') {
      for (let i = 0; i < call_template_patient.length; i++) {
        if (call_template_patient[i].name == e.value) {
          setCallTemplate(call_template_patient[i].value)
        }
      }
    }

  }
  const handleCallNotes = (e) => {
    setCallNotes({ 'is_valid': 'valid', 'value': e?.value })
  }
  const getCheckBoxValue = (e) => {
    setCheckBox(e?.value)
    if (e?.value == true) {
      setFormHeight('790')
      setMessageBoxVisible(true)
    }
    else {
      setMessageBoxVisible(false)
      setFormHeight('690')
    }
  }
  const getCheckBoxValue2 = (e) => {
    setCheckBox2(e?.value)
    setSendEmail(e?.value)

  }
  const ResetStates = () => {
    setCenterName({ "is_valid": 'valid', "value": null })
    setCallerNumber({ "is_valid": 'valid', "value": null })
    setCallerType({ "is_valid": 'valid', "value": null })
    setCallerName({ "is_valid": 'valid', "value": null })
    setMoreDetails({ "is_valid": 'valid', "value": null })
    setPatientDOB({ "is_valid": 'valid', "value": null })
    setCallContext({ "is_valid": 'valid', "value": null })
    setCallNotes({ "is_valid": 'valid', "value": null })
    setCallSummary({ "is_valid": 'valid', "value": null })
    setSmsText({ "is_valid": 'valid', "value": null })
    setCallTemplate([])
    setCallTemplateVisible('valid')
    setCheckMail(false)
    setCheckBox(false)
    setCheckBox2(false)
    setDOBDisable(false)
    setMoreDetailsVisible(false)
    setCallContextVisible(true)
    setIsUpdate(false)
    setSendEmail(false)
    setReadOnly(false)

  }

  const checkValidation = () => {

    let required_check = true;



    if (center_name?.value === null && is_update == false) {
      setCenterName({ "is_valid": 'invalid', "value": null })
      required_check = false;
    }
    if (caller_type?.value === null && is_update == false) {
      setCallerType({ "is_valid": 'invalid', "value": null })
      required_check = false;

    }
    if (caller_number?.value === null && is_update == false) {
      setCallerNumber({ "is_valid": 'invalid', "value": null })
      required_check = false;

    }
    if (
      (caller_name?.value === null || 
      ['', 'dr', 'dr.', 'doctor'].includes(caller_name?.value?.trim().toLowerCase())) && is_update == false) {
      if (caller_name?.value?.trim() !== null || caller_name?.value?.trim() !== '') {
        setCallerName({ "is_valid": 'invalid', "value": 'Dr ' })
      } else {
        setCallerName({ "is_valid": 'invalid', "value": null })
      }
      required_check = false;

    }
    if (call_notes?.value === null) {
      setCallNotes({ "is_valid": 'invalid', "value": null })
      required_check = false;

    }

    if (call_context?.value === null && call_context_visible == true && is_update == false) {
      setCallContext({ "is_valid": 'invalid', "value": null })
      required_check = false;

    }
    if (call_template.length == 0 && call_context_visible == true && is_update == false) {
      setCallTemplateVisible('invalid')
      required_check = false;


    }
    if (dob_disable == true && patient_dob?.value == null && is_update == false) {
      setPatientDOB({ "is_valid": 'invalid', "value": null })
      required_check = false;



    }
    if (more_details_visible == true && more_details?.value === null && is_update == false) {
      setMoreDetails({ "is_valid": 'invalid', "value": null })
      required_check = false;



    }
    if (message_box_visible == true && sms_text?.value === null) {
      setSmsText({ "is_valid": 'invalid', "value": null })
      required_check = false;

    }



    return required_check;





  }
  const onDataSave = (e) => {
    setSendingRequest(true)

    if (checkValidation() == true) {
      let data = {
        'call_source': 'DIRECT_CALL',
        'center_id': center_name?.value != null ? parseInt(center_name?.value) : null,
        'caller_number': caller_number?.value != null ? caller_number?.value.toString() : null,
        'caller_type': caller_type?.value != null ? caller_type?.value : null,
        'caller_name': caller_name?.value != null ? caller_name?.value : null,
        'more_details': more_details?.value != null ? more_details?.value : null,
        'patient_dob': moment(patient_dob?.value).isValid() ? moment(patient_dob?.value).format('YYYY-MM-DD') : null,
        'call_context': call_context?.value != null ? call_context?.value : null,
        'call_notes': call_notes?.value != null ? call_notes?.value : null,
        'urgent_call': checkbox,
        'call_summary': call_summary?.value != null ? call_summary?.value : null,
        'sms_text': sms_text?.value != null ? sms_text?.value : null,
        'send_email': send_email,
        'is_update': is_update,
        'db_id': props?.dataSource?.id,
        'conversation_id': props?.dataSource?.conversation_id
      }

      axios({
        method: "POST",
        url: SAVE_DIRECT_CALL,
        data: data,
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('MyToken')}`,
        },
        withCredentials: true
      }).then((response) => {
        if (response.status == 200) {
          if (response.data.error_code != 500) {
            setSendingRequest(false)
            toast.success('Succesfully Updated', {
              position: toast.POSITION.TOP_RIGHT
            });
            ResetStates();
            if (is_update == true) {
              setTimeout(function () { props?.OpenEdit(); }, 2000);
            }
          }
          else {
            setSendingRequest(false)
            toast.error(response?.data?.error_description, {
              position: toast.POSITION.TOP_RIGHT
            });
          }
        }
        else {
          setSendingRequest(false)
          toast.error('Network error', {
            position: toast.POSITION.TOP_RIGHT
          });
        }
      }).catch((error) => {
        setSendingRequest(false)
        toast.error('Backend connection refused', {
          position: toast.POSITION.TOP_RIGHT
        });
      })
    }
    else {
      setSendingRequest(false)
      toast.error('Please fill all the required fields', {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }



  const sortAnListOfObj = (a, b) => {
    if (a.display_name > b.display_name) {
      return 1;
    }
    if (a.display_name < b.display_name) {
      return -1;
    }
    return 0;
  };

  useEffect(() => {
    if (operatorAssignedCenters) {
      if (operatorAssignedCenters) {
        let modifiedCenters = [];

        for (let i = 0; i < operatorAssignedCenters.length; i++) {
          modifiedCenters.push({
            ...operatorAssignedCenters[i],
            center_name: `[${operatorAssignedCenters[i].center_prefix}] - ${operatorAssignedCenters[i].center_name} `,
          });
        }

        // Sorting an list of obj via center name
        setCenterList([...modifiedCenters.sort(sortAnListOfObj)]);
      } else {
        setCenterList([]);
      }
    }
  }, [operatorAssignedCenters]);

  useEffect(() => {

    if (props?.dataSource != undefined && props?.center_details != undefined) {
      setReadOnly(true);
      setIsUpdate(true)
      setCheckMail(true)
      setSendEmail(props?.dataSource?.send_email)
      setCenterName({ "is_valid": 'valid', "value": props?.center_details[0]?.center_id })
      setCallerName({ "is_valid": 'valid', "value": props?.dataSource?.caller_name })
      setCallerNumber({ "is_valid": 'valid', "value": props?.dataSource?.caller_number })
      setCallNotes({ "is_valid": 'valid', "value": props?.dataSource?.call_notes })
      setCallerType({ "is_valid": 'valid', "value": props?.dataSource?.caller_type })
      setCallContext({ "is_valid": 'valid', "value": props?.dataSource?.call_context })
    }
  }, []);

  return (
    <>
      <ToastContainer style={{ marginTop: '50px' }} />
      {/* <p>{center_name?.value}</p> */}
      <div style={{ background: 'rgba(238, 238, 238, 0.4)', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '30px', overflowY: 'auto' }}>
          <div>
            <div style={{ width: '900', height: form_height, background: '#fff', borderRadius: '20px', marginBottom: '60px' }}>
              <div style={{ paddingTop: '20px', paddingLeft: '20px', paddingRight: '20px', paddingBottom: '20px' }}>
                {/* <div style={{ color: '#000', fontSize: '16px', fontWeight: '550' }}>
                  Direct call handling
                </div> */}
                {/* <div style={{ color: '#b0b0b0', fontSize: '12px', fontWeight: '500', paddingTop: '1px' }}>
                  Fill in the required information
                </div> */}
                <div style={{ display: 'flex', justifyContent: 'left' }}>
                  <div>
                    <div style={{ display: 'flex' }}>
                      <div style={{ marginTop: '20px', paddingLeft: '15px' }}>
                        <SelectBox placeholder="" readOnly={read_only} label="Select Center" searchEnabled={true} value={center_name?.value} onValueChanged={handleCenterName} dataSource={centerList} valueExpr={'center_id'} displayExpr={'center_name'} width={280} height={45} style={{ borderRadius: '200px' }} validationStatus={center_name?.is_valid}></SelectBox>
                      </div>
                      <div style={{ marginTop: '20px', paddingLeft: '15px' }}>
                        <SelectBox placeholder="" readOnly={read_only} label="Caller Type" value={caller_type?.value} dataSource={caller_type_data} onValueChanged={handleCallerType} width={250} height={45} validationStatus={caller_type?.is_valid} />
                      </div>
                      <div style={{ marginTop: '20px', paddingLeft: '15px' }}>
                        <SelectBox placeholder="" readOnly={read_only} label="Call Context" value={call_context?.value} displayExpr='name' valueExpr={'value'} visible={call_context_visible} dataSource={call_context_data} onValueChanged={handleCallContext} width={250} height={45} validationStatus={call_context?.is_valid}
                        />
                      </div>
                      <div style={{ marginTop: '20px' }}>
                        <TextBox label="Others Detail" readOnly={read_only} placeholder="" value={more_details?.value} visible={more_details_visible} onValueChanged={handleMoreDetails} width={250} height={45} style={{ paddingLeft: '15px' }} validationStatus={more_details?.is_valid}></TextBox>
                      </div>
                    </div>
                    <div style={{ display: 'flex' }}>

                      <div style={{ marginTop: '30px', paddingLeft: '15px' }}>

                        <TextBox label="Caller Number" readOnly={read_only} mask="000000009" labelMode="static"
                          value={caller_number?.value} onValueChanged={handleCallerNumber} width={280} height={45} validationStatus={caller_number?.is_valid}>

                        </TextBox>
                      </div>




                      <div style={{ marginTop: '30px', paddingLeft: '15px', display: 'flex' }}>
                        <TextBox label="Caller Name" readOnly={read_only} placeholder="" value={caller_name?.value} onValueChanged={handleCallerName} width={caller_type?.value == 'Patient' ? 250 : 250} height={45} validationStatus={caller_name?.is_valid}></TextBox>
                        <DateBox displayFormat="dd-MM-yyyy" readOnly={read_only} showClearButton={true} useMaskBehavior={true} acceptCustomValue={true} openOnFieldClick={false} label="Patient DOB" value={patient_dob?.value} visible={dob_disable} onValueChanged={handlePatientDOB} style={{ marginLeft: '15px' }} width={caller_type?.value == 'Patient' ? 250 : 250} height={45} validationStatus={patient_dob?.is_valid} />

                      </div>
                    </div>
                    {read_only == false && <>
                      <div style={{ marginTop: '30px', paddingLeft: '15px', display: 'flex' }}>
                        {/* <TextBox label="Summary" placeholder="" value={call_summary?.value} onValueChanged={handleCallSummary} width={810} height={45} ></TextBox> */}
                        <SelectBox placeholder="" label="Select Template" visible={call_context_visible} displayExpr='name' dataSource={call_template} onValueChanged={handleCallTemplate} width={810} height={45} validationStatus={is_call_template_requeired}
                        />
                      </div>
                    </>}
                    <div style={{ marginTop: '30px', paddingLeft: '15px' }}>
                      <TextArea label="Notes" placeholder="" width={810} value={call_notes?.value} onValueChanged={handleCallNotes} maxHeight={230} height={230} validationStatus={call_notes?.is_valid}></TextArea>
                    </div>
                    {checkMail == true && <>

                      <div style={{ marginTop: '10px', paddingLeft: '20px', display: 'flex' }}>

                        <div>
                          <CheckBox
                            height={45}
                            disabled={false}
                            value={checkbox2}
                            onValueChanged={getCheckBoxValue2}
                          />
                        </div>
                        <div style={{ marginLeft: '10px', marginTop: '13px', fontSize: '11px', lineHeight: '15px', marginLeft: '10px' }}>
                          Notify to customer via EMAIL (urgent)
                        </div>
                      </div>
                    </>}

                    <div style={{ paddingLeft: '20px', display: 'flex' }}>

                      <div >
                        <CheckBox
                          height={45}
                          disabled={false}
                          value={checkbox}
                          onValueChanged={getCheckBoxValue}
                        />
                      </div>
                      <div style={{ marginLeft: '10px', marginTop: '13px', fontSize: '11px', lineHeight: '15px', marginLeft: '10px' }}>
                        Notify to customer via SMS (urgent)
                      </div>
                    </div>



                    <div style={{ marginTop: '10px', paddingLeft: '15px' }}>
                      <TextArea label="SMS" visible={message_box_visible} placeholder="Please type SMS content" width={810} value={sms_text?.value} onValueChanged={handleSmsText} maxHeight={60} height={60} validationStatus={sms_text?.is_valid}></TextArea>
                    </div>
                    <div style={{ marginTop: '15px', textAlign: 'left', paddingLeft: '15px', marginBottom: '20px' }}>
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                          width={200}
                          style={{ borderRadius: '8px', background: '#6c26e7', color: '#fff', height: '40px' }}
                          onClick={onDataSave}
                          disabled={sendingRequest}
                        >
                          {is_update == false ? 'Save' : 'Update'}
                        </Button>
                        {is_update != true && <>
                          <Button
                            width={150}
                            style={{ borderRadius: '8px', background: '#eee', color: '#000', height: '40px', marginLeft: '10px' }}
                            onClick={ResetStates}
                            disabled={sendingRequest}
                          >
                            Reset
                          </Button></>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectCall;


